const toggle = document.querySelector('[data-locations-toggle]');
const moreLocations = document.querySelector('[data-more-locations]');

if (toggle && moreLocations) {
    toggle.addEventListener('click', () => {
        moreLocations.hidden = false;
        toggle.hidden = true;
    });

    moreLocations.querySelector('[data-locations-collapse]')?.addEventListener('click', () => {
        moreLocations.hidden = true;
        toggle.hidden = false;
        toggle.scrollIntoView({block: 'nearest'});
    });
}

const bar = document.querySelector('[data-scoring-bar]');
const card = document.querySelector('.wc-review-card');
const vendorBox = document.querySelector('.wc-review-box--vendor');

if (bar && card) {
    bar.hidden = false;

    const items = [...bar.querySelectorAll('[data-scoring-target]')];
    const headings = items.map(item => document.getElementById(item.dataset.scoringTarget)).filter(Boolean);
    const desktop = window.matchMedia('(min-width: 1023px)');
    let pending = false;

    // a scroll check, not an observer: a jump (an anchor, back to top) skips over the trigger without ever intersecting it
    const update = () => {
        pending = false;

        const passed = desktop.matches || !headings.length
            ? (desktop.matches && vendorBox || card).getBoundingClientRect().bottom < 0
            : headings[0].getBoundingClientRect().top < 0;

        bar.classList.toggle('is-visible', passed);
        // legacy parks the accessibility button in the bar's corner while the bar is up
        document.querySelector('.asw-widget .asw-menu-btn')?.classList.toggle('asw-menu-btn-top', passed);
    };

    window.addEventListener('scroll', () => {
        if (!pending) {
            pending = true;
            requestAnimationFrame(update);
        }
    }, {passive: true});
    desktop.addEventListener('change', update);
    update();

    if (headings.length && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    items.forEach(item => item.classList.toggle('is-active', item.dataset.scoringTarget === entry.target.id));
                }
            });
        }, {rootMargin: '0px 0px -70% 0px'});

        headings.forEach(heading => observer.observe(heading));
    }
}

document.querySelectorAll('[data-alternatives]').forEach(block => {
    const tabs = [...block.querySelectorAll('[role="tab"]')];
    const list = block.querySelector('[role="tablist"]');
    const select = tab => {
        const start = tabs.indexOf(tab);

        // legacy turns the tabs like a carousel, the active one always first
        tabs.forEach((other, index) => {
            const active = other === tab;

            other.classList.toggle('is-active', active);
            other.setAttribute('aria-selected', active ? 'true' : 'false');
            other.style.order = String((index - start + tabs.length) % tabs.length);
            document.getElementById(other.getAttribute('aria-controls')).hidden = !active;
        });

        list.scrollLeft = 0;
    };

    tabs.forEach(tab => tab.addEventListener('click', () => select(tab)));

    block.querySelectorAll('[data-alternatives-step]').forEach(arrow => {
        arrow.addEventListener('click', () => {
            const current = tabs.findIndex(tab => tab.classList.contains('is-active'));
            const next = (current + Number(arrow.dataset.alternativesStep) + tabs.length) % tabs.length;

            select(tabs[next]);
        });
    });
});
